import type { UserAiMessage } from '@entities/user';

export const getAdminSenderDisplayName = (
  sender: UserAiMessage['sender']
): string => {
  if (!sender) {
    return 'Администратор';
  }

  const name = [sender.firstName, sender.lastName].filter(Boolean).join(' ');

  return name || 'Администратор';
};

export const getUserAiMessageDisplay = (
  msg: UserAiMessage,
  employerDisplayName: string
): { sender: 'self' | 'other'; senderName: string; isAi: boolean } => {
  if (msg.authorType === 'AI') {
    return { sender: 'other', senderName: 'Синтия', isAi: true };
  }

  if (msg.authorType === 'Admin') {
    return {
      sender: 'other',
      senderName: getAdminSenderDisplayName(msg.sender),
      isAi: false,
    };
  }

  return { sender: 'self', senderName: employerDisplayName, isAi: false };
};
